import { IconWrapper } from '@/components/ui/IconWrapper';
import { cn } from '@/utils/cn';
import { formatTimestamp } from '@/utils/date';
import { MailOutlined } from '@ant-design/icons';

import type { Notification } from '../types/Notifications.types';

interface NotificationItemProps {
  notification: Notification;
  onClick: (notification: Notification) => void;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({ notification, onClick }) => {
  const handleNotificationClick = () => {
    onClick(notification);
  };
  return (
    <div onClick={handleNotificationClick}>
      <div
        className={cn(
          'flex cursor-pointer items-start gap-3 rounded-lg bg-white p-3 transition-colors hover:bg-gray-50'
        )}
      >
        <IconWrapper icon={MailOutlined} className="text-primary-800 text-md mt-[-4px]" />
        <div className="flex-1">
          <div className="text-typography-400 mb-1 text-xs font-semibold">
            {formatTimestamp(notification.timestamp)}
          </div>
          <p className={cn('text-sm font-normal text-gray-900')}>{notification.title}</p>
        </div>
      </div>
    </div>
  );
};
